import React, { useEffect, useState } from "react";
import { SkiplyPurpleLogo, RAKbankLogo, FillCircleLogo, UnfillCircleLogo, SuccessLogo } from "../../assets/icons/index.js";
import OtpInput from "./OtpInput.js";
import WarningMessage from "./WarningMessage.js";
import { ModalPopUp } from "../../components";
import { API_URL } from "../../utils/Constants.js";
import { ApiService } from "../../utils/ApiService.js";
const Remove = () => {
    const availableReasons = [
        {
            id: 0,
            title:
                "Application was slow, crashed frequently, or had other performance-related issues.",
        },
        {
            id: 1,
            title:
                "Application difficult to navigate, confusing, or lacking in intuitive design.",
        },
        {
            id: 2,
            title:
                "Any features you wish the app had but didn't, or if the existing features were not meeting their needs.",
        },
        {
            id: 3,
            title:
                "Had concerns about privacy or data security while using the application.",
        },
        { id: 4, title: "Others." },
    ];
    const [reasons, setReasons] = useState(availableReasons);
    const [heading, setHeading] = useState("");
    const [subHeadings, setSubHeadings] = useState([]);
    const [activeTab, setActiveTab] = useState(1); // State to manage active tab
    const [selectedReasonedID, setSelectedReasonedID] = useState(-1);
    const [email, setEmail] = useState("");
    const [otpToken, setOtpToken] = useState("");
    const [isEmailWarning, setIsEmailWarning] = useState(false);
    const [isSelectedReason, setIsSelectedReason] = useState(false);
    const [showSnack, setShowSnack] = useState(false);
    const [isInProcess, setIsInProcess] = useState(false);
    const [snackMsg, setSnackMsg] = useState("");
    const emailRef = React.createRef();

    useEffect(() => {
        if (activeTab === 2) {
            emailRef.current.focus();
        }
    }, [email]);

    useEffect(() => {
        fetchAppInfo();
    }, []);

    const fetchAppInfo = async () => {
        try {
            setIsInProcess(true);
            const resp = await ApiService.getRequestWithoutAuth(API_URL.APP_INFO);
            if (resp.status && resp.status.code === "Y") {
                let parsedData = JSON.parse(resp.body);
                let deleteAppReasons = parsedData?.deleteAppReasons;
                if (deleteAppReasons?.reasons?.length > 0) {
                    setReasons(deleteAppReasons.reasons);
                }
                if (deleteAppReasons?.descriptions?.length > 0) {
                    setHeading(deleteAppReasons?.descriptions[0].content);
                }
                if (deleteAppReasons?.descriptions?.length > 1) {
                    setSubHeadings(deleteAppReasons?.descriptions.slice(1));
                }
            } else {
                setShowSnack(true);
                setSnackMsg(
                    resp?.status?.message ||
                    resp?.status?.errorCode ||
                    "Our Server is down, please try again"
                );
            }
        } catch (err) {
            setShowSnack(true);
            setSnackMsg("Our Server is down, please try again");
        } finally {
            setIsInProcess(false);
        }
    };

    const handleCheckId = (id) => {
        return selectedReasonedID === id;
    };

    function validateEmail(email) {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function validateOTP(otp) {
        const re = /^\d{6}$/;
        return re.test(String(otp));
    }

    const checkDisablitity = () => {
        if (email == "" || !validateEmail(email)) {
            setIsEmailWarning(true);
        } else if (selectedReasonedID == -1) {
            setIsEmailWarning(false);
            setIsSelectedReason(true);
        } else {
            setIsEmailWarning(false);
            setIsSelectedReason(false);
            generateOtp();
        }
    };

    const generateOtp = async () => {
        try {
            const payload = {
                emailAddress: email,
                otpRequestType: "DELETE_USER",
                phoneEmail: "E",
                phoneNumber: "",
                phoneNumberCountryCode: "",
            };
            setIsInProcess(true);
            const resp = await ApiService.postRequestWithoutAuth(
                API_URL.GENERATE_OTP_REQUEST,
                payload
            );
            if (resp.status && resp.status.code === "Y") {
                setOtpToken(resp?.body?.otpToken);
                setActiveTab(3);
            } else {
                setShowSnack(true);
                setSnackMsg(
                    resp?.status?.message ||
                    resp?.status?.errorCode ||
                    "Something went wrong please try again"
                );
            }
        } catch (err) {
            setShowSnack(true);
            setSnackMsg("Something went wrong please try again");
        } finally {
            setIsInProcess(false);
        }
    };

    const reGenerateOtp = async () => {
        try {
            const payload = {
                emailAddress: email,
                otpRequestType: "DELETE_USER",
                otpToken: otpToken,
                phoneEmail: "E",
                phoneNumber: "",
                phoneNumberCountryCode: "",
            };
            setIsInProcess(true);
            const resp = await ApiService.postRequestWithoutAuth(
                API_URL.REGENERATE_OTP_REQUEST,
                payload
            );
            if (resp.status && resp.status.code === "Y") {
                setOtpToken(resp?.body?.otpToken);
            } else {
                setShowSnack(true);
                setSnackMsg(
                    resp?.status?.message ||
                    resp?.status?.errorCode ||
                    "Something went wrong please try again"
                );
            }
        } catch (err) {
            setShowSnack(true);
            setSnackMsg("Something went wrong please try again");
        } finally {
            setIsInProcess(false);
        }
    };

    const resetValues = () => {
        setActiveTab(1);
        setEmail("");
        setSelectedReasonedID(-1);
        setIsEmailWarning(false);
        setIsSelectedReason(false);
        onCloseSnack();
    };

    function handleGotoFAQs() {
        window.open("https://skiply.ae/files/Skiply-FAQs.pdf", "_blank");
    }
    function handleGotoTerms() {
        window.open("https://skiply.ae/files/Skiply-T&C.pdf", "_blank");
    }

    function handleGotoPrivacy() {
        window.open("https://www.rakbank.ae/en/privacy-policy", "_blank");
    }

    function handleGotoContactUs() {
        window.location.href = "mailto:contactus@skiply.ae";
    }

    const onCloseSnack = () => {
        setShowSnack(false);
        setSnackMsg("");
    };

    const GoToScreens = (index) => {
        if (index == 0) {
            handleGotoFAQs();
        }
        if (index == 1) {
            handleGotoTerms();
        }
        if (index == 2) {
            handleGotoPrivacy();
        }
        if (index == 3) {
            handleGotoContactUs();
        }
    };

    const NavBar = () => {
        const navLinks = [
            "FAQs",
            "Terms & Conditions",
            "Privacy Policy",
            "Contact us",
        ];

        return (
            <nav className="navbar">
                <div className="logo">
                    <SkiplyPurpleLogo />
                </div>

                <div className="nav-links">
                    {navLinks.map((link, index) => (
                        <a
                            href={`#${link.toLowerCase()}`}
                            key={index}
                            className="nav-item"
                            onClick={() => GoToScreens(index)}
                        >
                            {link}
                        </a>
                    ))}
                </div>
            </nav>
        );
    };

    const Footer = () => {
        const footerLinks = [
            "FAQs",
            "Terms & Conditions",
            "Privacy Policy",
            "Contact us",
        ];

        return (
            <footer className="footer-container">
                <div className="footer-content">
                    <div className="footer-top">
                        <div className="footer-logo">
                            <SkiplyPurpleLogo /
                            >
                        </div>

                        <div className="footer-links">
                            {footerLinks.map((link, index) => (
                                <a
                                    href={`#${link.toLowerCase()}`}
                                    key={index}
                                    className="footer-item"
                                    onClick={() => GoToScreens(index)}
                                >
                                    {link}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="service-section">
                            <span className="service-text">a service from</span>
                            <div className="service-logos">
                                <RAKbankLogo></RAKbankLogo>
                            </div>
                        </div>
                        <span className="copyright">© Copyright by Rakbank 2023</span>
                    </div>
                </div>
            </footer>
        );
    };

    const PrimaryButton = ({ title, onPress, disabled }) => {
        let buttonClass = disabled ? "primary-button-disabled" : "primary-button";
        return (
            <button className={buttonClass} onClick={onPress} disabled={disabled}>
                {title}
            </button>
        );
    };

    const HelpSection = ({ key }) => {
        return (
            <section className="help-section" key={key}>
                <h2 className="help-title">I need help deleting my Skiply account</h2>
                <div className="help-content">
                    <p className="help-text">{heading}</p>
                    <a
                        href="#"
                        className="help-link"
                        onClick={() => {
                            setActiveTab(2);
                        }}
                    >
                        Delete my Skiply account
                    </a>
                    {subHeadings.map((item, index) => (
                        <p className="help-description">
                            {item.title}
                            {item.content && (
                                <span className="highlight">
                                    <br />
                                    {item.content}
                                </span>
                            )}
                        </p>
                    ))}
                </div>
            </section>
        );
    };

    const EmailSection = ({ key }) => {
        const PrivacyConcern = ({ title, id, index, isError }) => {
            return (
                <section
                    className="privacy-concern"
                    key={index}
                    onClick={() => {
                        setSelectedReasonedID(id);
                    }}
                >
                    <div className="icon">
                        {handleCheckId(id) ? (
                            <FillCircleLogo />) : (
                            <UnfillCircleLogo
                                color={isError ? "#F15A61" : "#7950FF"}
                            ></UnfillCircleLogo>
                        )}
                    </div>
                    <p className="privacy-item-text">{title}</p>
                </section>
            );
        };

        return (
            <section className="help-section" key={key}>
                <h2 className="help-title">What’s your email?</h2>
                <div className="help-content">
                    <input
                        ref={emailRef}
                        type="email"
                        className="info-value"
                        value={email}
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {isEmailWarning && (
                        <WarningMessage title={"Please enter your valid email"} />
                    )}
                    <p className="reason-text">
                        Reason to delete
                        <span className="asterisk">*</span>
                    </p>

                    <div className="privacy-concern-container">
                        {reasons.map((reason, index) => (
                            <PrivacyConcern
                                title={reason.title}
                                id={reason.id}
                                key={index}
                                isError={isSelectedReason}
                            />
                        ))}
                        {isSelectedReason && (
                            <WarningMessage
                                title={"Please select your reason to delete account"}
                            />
                        )}
                    </div>

                    <PrimaryButton
                        title="Continue"
                        onPress={checkDisablitity}
                        disabled={isInProcess}
                    />
                </div>
            </section>
        );
    };

    const OTPSection = ({ key }) => {
        const [isOtpError, setIsOtpError] = useState(false);
        const [OtpIs, setOtpIs] = useState("");
        const onOtpCallback = (text) => {
            setOtpIs(text);
            if (text.length == 6) {
                setIsOtpError(false);
            }
        };

        const onOtpVerifyHandler = () => {
            if (OtpIs.length != 6 || !validateOTP(OtpIs)) {
                setIsOtpError(true);
            } else {
                verifyOtp();
                setIsOtpError(false);
            }
        };

        const verifyOtp = async () => {
            try {
                const payload = {
                    countryCode: "",
                    errorMessage: "",
                    otp: OtpIs,
                    otpRequestType: "DELETE_USER",
                    otpToken: otpToken,
                    verifierType: "",
                    verifierValue: "",
                };
                setIsInProcess(true);
                const resp = await ApiService.postRequestWithoutAuth(
                    API_URL.VERIFY_OTP_REQUEST,
                    payload
                );
                if (resp.status && resp.status.code === "Y") {
                    const auth = resp?.body?.authorization;
                    const xAuth = resp?.body?.userAccessToken;
                    if (auth) localStorage.setItem("bearer", auth);
                    if (xAuth) localStorage.setItem("x-auth-token", xAuth);
                    deleteUser();
                } else {
                    setShowSnack(true);
                    setSnackMsg(
                        resp?.status?.message ||
                        resp?.status?.errorCode ||
                        "Something went wrong please try again"
                    );
                }
            } catch (err) {
                setShowSnack(true);
                setSnackMsg("Something went wrong please try again");
            } finally {
                setIsInProcess(false);
            }
        };

        const deleteUser = async () => {
            try {
                const payload = {
                    feedback: "",
                    rating: 0,
                    reason: reasons[selectedReasonedID].title,
                };
                setIsInProcess(true);
                const resp = await ApiService.deleteRequestWithXAuth(
                    API_URL.DELETE_USER_PROFILE,
                    payload
                );
                if (resp.status && resp.status.code === "Y") {
                    setActiveTab(4);
                } else {
                    setShowSnack(true);
                    setSnackMsg(
                        resp?.status?.message ||
                        resp?.status?.errorCode ||
                        "Something went wrong please try again"
                    );
                }
            } catch (err) {
                setShowSnack(true);
                setSnackMsg("Something went wrong please try again");
            } finally {
                setIsInProcess(false);
            }
        };

        return (
            <section className="help-section" key={key}>
                <h2 className="help-title">Enter the 6-digits code sent to you at:</h2>
                <div className="help-content">
                    <input
                        type="email"
                        className="info-value-disabled"
                        disabled
                        value={email}
                    />

                    <div className="privacy-concern-container">
                        <OtpInput
                            onResendCallBack={reGenerateOtp}
                            onCallBack={onOtpCallback}
                            isError={isOtpError}
                        />
                        {isOtpError && (
                            <WarningMessage title={"Please enter your valid OTP"} />
                        )}
                    </div>

                    <PrimaryButton
                        title="Verify OTP & Proceed"
                        onPress={onOtpVerifyHandler}
                        disabled={isInProcess}
                    />
                </div>
            </section>
        );
    };

    const SuccessSection = ({ key }) => {
        return (
            <section className="help-section" key={key}>
                <div className="success-icon">
                    <SuccessLogo />
                </div>

                <h2 className="help-title center-title">Account Deleted</h2>

                <div className="help-content">
                    <p className="help-text center-title">
                        Your account was successfully deleted from Google Play
                    </p>

                    <PrimaryButton title="Back to home page" onPress={resetValues} />
                </div>
            </section>
        );
    };

    return (
        <div className="app-container">
            <NavBar />
            {activeTab === 1 && <HelpSection key={"1"} />}
            {activeTab === 2 && <EmailSection key={"2"} />}
            {activeTab === 3 && <OTPSection key={"3"} />}
            {activeTab === 4 && <SuccessSection key={"4"} />}
            <ModalPopUp
                isVisible={showSnack}
                title="Information"
                bodyMsg={snackMsg}
                onHide={onCloseSnack}
            />
            <Footer />
            <style jsx>{`
        .center-title {
          text-align: center;
        }
        .success-icon {
          margin-bottom: 22px;
          align-self: center;
          align-items: center;
          justify-content: center;
        }

        @media (max-width: 991px) {
          .success-icond {
            margin-bottom: 16px;
          }
        }

        .primary-button {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          background-color: var(--Blue-Main-Purple, #7950ff);
          color: var(--Color-Text-Primary-On-Dark, #fff);
          text-align: center;
          padding: 12px 24px;
          font: 500 16px/1.5 "DM Sans", -apple-system, Roboto, Helvetica,
            sans-serif;
          border: none;
          cursor: pointer;
          margin-top: 16px;
        }

        .primary-button-disabled {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          background: var(--Input-BG, #f5f5f5);
          color: var(--UI-Grey, #838993);
          text-align: center;
          padding: 12px 24px;
          font: 500 16px/1.5 "DM Sans", -apple-system, Roboto, Helvetica,
            sans-serif;
          border: none;
          cursor: pointer;
          margin-top: 16px;
        }

        @media (max-width: 991px) {
          .primary-button-disabled {
            margin-top: 0px;
          }
        }

        @media (max-width: 991px) {
          .primary-button {
            margin-top: 0px;
          }
        }

        .reason-text {
          margin-top: 32px;
          color: var(--UI-Grey, #838993);
          align-self: start;
          text-align: left;
          font-family: DM Sans, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
        .asterisk {
          color: rgba(241, 90, 97, 1);
        }

        .privacy-concern-container {
          display: flex;
          flex-direction: column;
        }

        .privacy-concern {
          display: flex;
          flex-direction: row;
        }

        .icon {
          align-self: start;
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }

        .privacy-item-text {
          color: var(--UI-Black, #0e0e0e);
          font-family: DM Sans, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }

        @media (max-width: 991px) {
          .footer-item {
            text-align: center;
          }
        }

        .info-value {
          border: none;
          outline: none;
          padding: 10px;
          border-radius: 10px;
          background-color: var(--Input-BG, #f5f5f5);
        }

        .info-value-disabled {
          border: none;
          outline: none;
          padding: 10px 10px 10px 0px;
          background-color: var(--Input-BG, #ffff);
          margin-bottom: 16px;
        }

        .app-container {
          background-color: #fff;
          display: flex;
          flex-direction: column;
        }
        .navbar {
          background-color: #7950ff;
          display: flex;
          width: 100%;
          justify-content: space-around;
          flex-direction: row;
          align-items: flex-start;
          padding: 26px 60px 80px;
          height: 453px;
        }
        @media (max-width: 991px) {
          .navbar {
            padding: 30px 20px;
            height: 200px;
            justify-content: flex-start;
            align-items: flex-start;
          }
        }
        .logo {
          width: 85px;
          height: 31px;
          align-self: flex-start;
          align-items: flex-start;
        }
        .nav-links {
          display: flex;
          gap: 20px;
          margin-top: 8px;
        }
        @media (max-width: 991px) {
          .nav-links {
            display: none;
          }
        }
        .nav-item {
          color: #fff;
          letter-spacing: 2px;
          text-transform: uppercase;
          font: 500 14px/143% DM Sans, sans-serif;
        }
        .help-section {
          position: relative;
          border-radius: 32px;
          box-shadow: 0px 10px 30px 0px rgba(133, 145, 146, 0.1);
          border: 1px solid rgba(230, 230, 230, 1);
          background-color: #fff;
          align-self: center;
          z-index: 10;
          display: flex;
          margin-top: -253px;
          width: 632px;
          max-width: 100%;
          flex-direction: column;
          justify-content: center;
          padding: 56px;
        }
        @media (max-width: 991px) {
          .help-section {
            margin-top: -100px;
            padding: 20px;
            width: 90%;
          }
        }
        .help-title {
          color: #0e0e0e;
          font: 700 36px/40px DM Sans, sans-serif;
        }
        @media (max-width: 991px) {
          .help-title {
            font: 700 24px/26px DM Sans, sans-serif;
          }
        }
        .help-content {
          display: flex;
          margin-top: 32px;
          flex-direction: column;
          font-size: 16px;
          color: #838993;
          font-weight: 400;
          line-height: 24px;
        }
        @media (max-width: 991px) {
          .help-content {
            font: 700 16px/18px DM Sans, sans-serif;
          }
        }
        .help-text {
          margin-bottom: 24px;
        }
        .help-link {
          color: #7950ff;
          font-weight: 500;
          text-decoration: underline;
          margin-bottom: 24px;
        }
        .help-description {
          font-family: DM Sans, sans-serif;
        }
        .highlight {
          color: #838993;
        }

        .footer-container {
          align-items: center;
          background-color: #0e0e0e;
          display: flex;
          margin-top: 40px; /* Adjusted margin */
          width: 100%;
          justify-content: center;
          padding: 80px 60px; /* Adjusted padding */
        }

        @media (max-width: 991px) {
          .footer-container {
            padding: 30px; /* Adjusted padding for responsiveness */
          }
        }

        .footer-content {
          display: flex;
          width: 1218px;
          max-width: 100%;
          flex-direction: column;
        }

        .footer-top {
          display: flex;
          width: 100%;
          gap: 20px;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px; /* Adjusted padding */
        }

        @media (max-width: 991px) {
          .footer-top {
            flex-direction: column;
            align-items: center;
            gap: 10px; /* Adjusted gap */
            padding: 0; /* Removed padding */
          }
        }

        .footer-logo {
          width: 85px;
          height: 31px;
        }

        @media (max-width: 991px) {
          .footer-logo {
            align-self: center;
            justify-content: center;
            align-items: center;
          }
        }
        .footer-links {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
          margin-top: 10px;
        }
        @media (max-width: 991px) {
          .footer-links {
            flex-direction: column;
            align-items: center;
          }
        }
        .footer-item {
          font-family: DM Sans, sans-serif;
          font-size: 14px;
          color: #fff;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 2px;
          line-height: 143%;
          padding: 20px 20px; /* Adjusted padding */
        }

        @media (max-width: 991px) {
          .footer-item {
            text-align: center;
          }
        }

        .footer-bottom {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 40px; /* Adjusted margin */
        }

        .service-section {
          display: flex;
          gap: 17px;
        }
        .service-text {
          color: #838993;
          margin: auto 0;
          font: 400 12px/133% DM Sans, sans-serif;
        }
        .service-logos {
          display: flex;
          gap: 6px;
        }
        .copyright {
          color: #838993;
          align-self: center;
          margin-top: 24px;
          font: 400 12px/133% DM Sans, sans-serif;
        }
      `}</style>
        </div>
    );
};

export default Remove;
